export default "__VITE_ASSET__0c9e8b5b__"